module.exports = __webpack_public_path__ + "img/warning.7d1ecf3e.svg";